import React from "react"
import { MdComputer } from "react-icons/md"
import { IoLink } from "react-icons/io5"
import { GrGallery } from "react-icons/gr"
import { FaCamera } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Tooltip } from "components"
import classes from "./FuwTabs.module.scss"

const FuwTabs = props => {
  const {
    options,
    tab,
    setTab,
    maxFilesReached,
    maxNumberOfUploads
  } = props

  const [t] = useTranslation()

  return (
    <div className={classes["container"]}>
      {
        options.device &&
        <Tooltip
          title={maxFilesReached
            ? t("حداکثر_maxNumberOfUploads_فایل_می_توان_انتخاب_کرد", { maxNumberOfUploads })
            : ""
          }
        >
          <button
            disabled={maxFilesReached}
            onClick={() => setTab("device")}
            className={clsx(
              classes["button"],
              tab === "device" && classes["active"]
            )}
          >
            <MdComputer size={20} />
            <span className={classes["text"]}>
              {t("دستگاه")}
            </span>
          </button>
        </Tooltip>
      }

      {
        options.link &&
        <Tooltip
          title={maxFilesReached
            ? t("حداکثر_maxNumberOfUploads_فایل_می_توان_انتخاب_کرد", { maxNumberOfUploads })
            : ""
          }
        >
          <button
            disabled={maxFilesReached}
            onClick={() => setTab("link")}
            className={clsx(
              classes["button"],
              tab === "link" && classes["active"]
            )}
          >
            <IoLink size={20} />
            <span className={classes["text"]}>
              {t("لینک")}
            </span>
          </button>
        </Tooltip>
      }

      {
        options.media &&
        <Tooltip
          title={maxFilesReached
            ? t("حداکثر_maxNumberOfUploads_فایل_می_توان_انتخاب_کرد", { maxNumberOfUploads })
            : ""
          }
        >
          <button
            disabled={maxFilesReached}
            onClick={() => setTab("media")}
            className={clsx(
              classes["button"],
              tab === "media" && classes["active"]
            )}
          >
            <GrGallery size={20} />
            <span className={classes["text"]}>
              {t("مدیا")}
            </span>
          </button>
        </Tooltip>
      }

      {
        options.camera &&
        <Tooltip
          title={maxFilesReached
            ? t("حداکثر_maxNumberOfUploads_فایل_می_توان_انتخاب_کرد", { maxNumberOfUploads })
            : ""
          }
        >
          <button
            disabled={maxFilesReached}
            onClick={() => setTab("camera")}
            className={clsx(
              classes["button"],
              tab === "camera" && classes["active"]
            )}
          >
            <FaCamera size={20} />
            <span className={classes["text"]}>
              {t("دوربین")}
            </span>
          </button>
        </Tooltip>
      }

    </div>
  )
}

export default FuwTabs